/* eslint-disable @typescript-eslint/explicit-function-return-type */
import routeNames from '@/router/routeNames'

import type { StrictRouteConfig } from 'types/router'

const ApplicationLayout = () => import('@/layouts/ApplicationLayout.vue')
const FeedPage = () => import('@/pages/Application/FeedPage.vue')
const ReviewPage = () => import('@/pages/Application/ApplicationReviewPage.vue')
const AttachmentsPage = () => import('@/pages/Application/AttachmentsPage.vue')
const PolicyDocsPage = () => import('@/pages/Application/PolicyDocsPage.vue')
const PrintPage = () => import('@/pages/Application/PrintPage.vue')
const SchedulePage = () => import('@/pages/Schedule/SchedulePage.vue')
const ComparePage = () => import('@/pages/Compare/ComparePage.vue')

export const routeConfig: StrictRouteConfig[] = [
  {
    // optional policyId prevents vue-router error incorrectly erroring on application > policy navigation
    // ApplicationLayout handles redirect if no id are provided
    path: '/policy/:policyId(\\d+)?',
    meta: { requiresAuth: true, applicationLayout: true },
    component: ApplicationLayout,
    props: true,
    children: [
      {
        path: '',
        redirect: { name: routeNames.POLICY_FEED },
      },
      {
        path: 'feed',
        redirect: { name: routeNames.POLICY_FEED },
      },
      {
        path: 'activity',
        component: FeedPage,
        name: routeNames.POLICY_FEED,
        meta: { isTabsList: true, policyView: true },
      },
      {
        name: routeNames.POLICY_REVIEW,
        path: 'details',
        component: ReviewPage,
        meta: { isTabsList: true, policyView: true, title: 'Policy Review' },
      },
      {
        path: 'attachments/:attachmentId?',
        name: routeNames.POLICY_ATTACHMENTS,
        component: AttachmentsPage,
        meta: { isTabsList: true, policyView: true, title: 'Attachments' },
      },
      {
        path: 'policy/:attachmentId?',
        name: routeNames.POLICY_POLICY_DOCS,
        component: PolicyDocsPage,
        meta: { isTabsList: true, policyView: true, title: 'Policy Documents' },
      },
      {
        name: routeNames.POLICY_PRINT,
        path: 'print',
        props: (route) => ({
          nestedDataPath: route.query.loc,
        }),
        component: PrintPage,
        meta: { isTabsList: false, hiddenFAB: true, policyView: true, title: 'Print' },
      },
      {
        name: routeNames.POLICY_SCHEDULE_REVIEW,
        path: 'schedule/:scheduleId/review',
        component: SchedulePage,
        meta: { isTabsList: false, hiddenFAB: true, policyView: true, title: 'Schedule Review' },
      },
      {
        path: 'compare',
        name: routeNames.POLICY_COMPARE_ENDORSEMENTS,
        component: ComparePage,
        meta: { policyView: true, title: 'Compare Endorsements' },
      },
    ],
  },
]

export default routeConfig
